var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductRecall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.1,19.9l-3.8-3.8c-2.4,3-3.8,6.6-4.3,10.3h5.4C9.7,24.1,10.6,21.9,12.1,19.9z M9.4,31.7H4C4.5,35.3,5.9,39,8.3,42l3.8-3.8C10.6,36.3,9.7,34.1,9.4,31.7z M12.1,45.7c3,2.4,6.6,3.8,10.3,4.3v-5.4c-2.4-0.5-4.6-1.3-6.5-2.7L12.1,45.7z M27.5,8.2V0l-12,12l12,11.7V13.4c7.4,1.3,13.2,7.7,13.2,15.6s-5.7,14.4-13.2,15.6V50C37.9,48.7,46,39.9,46,29C46,18.3,37.9,9.5,27.5,8.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductRecall);
export default __webpack_public_path__ + "static/media/product-recall.168fd50cc6e0341f0d1caa723409ab94.svg";
export { ForwardRef as ReactComponent };